import { useState, useEffect } from "react";

const useSubscriptionStatus = () => {
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkSubscriptionStatus = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/packages/my-subscription`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const subscription = await response.json();
        
        // Check if subscription is active and not expired
        const isActive = subscription.isActive && new Date(subscription.endDate) > new Date();
        
        setCurrentSubscription(subscription);
        setHasActiveSubscription(isActive);
      } else if (response.status === 404) {
        // No subscription found - user should see regular packages
        setHasActiveSubscription(false);
        setCurrentSubscription(null);
      } else {
        throw new Error('Failed to check subscription status');
      }
    } catch (err) {
      setError(err.message);
      setHasActiveSubscription(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  const refetch = () => {
    checkSubscriptionStatus();
  };

  return {
    hasActiveSubscription,
    currentSubscription,
    loading,
    error,
    refetch
  };
};

export default useSubscriptionStatus; 